import { createActions } from '../../context';
import * as actions from './reports.actions';

export const reports = store => ({
    providers: [],
    tradeRuleCoursesList: [],
    soldVsUnsoldReportMessage: '',
    soldReportMessage: '',
    bankingAndReAllocationsReportMessage: '',
    actions: createActions(actions)(store)
});